export default __webpack_public_path__ + "static/media/Tutorial-Step-5.79a24e8f.jpg";